import { IReturn, IReturnQuery } from './models';

const subscriptionKey = process.env.SUBSCRIPTION_KEY;
const baseUrl = process.env.BACKEND_URL;

const source = { hybris: 'hybris' };

const wrappedFetch = (url: string, options: any = {}) => {
  const _options = {
    ...options,
    headers: {
      'Ocp-Apim-Subscription-Key': subscriptionKey,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };
  return fetch(url, _options);
};

export const getOrderByIdAndPostCode = (orderNr: string, postCode: string) => {
  return wrappedFetch(`${baseUrl}/${source['hybris']}/${orderNr}?match=${postCode}`).then((res) =>
    res.json(),
  );
};

export const getOrder = (ordernr: string, postCode: string) => {
  return wrappedFetch(`${baseUrl}?orderId=${ordernr}&postCode=${postCode}`)
    .then((d) => {
      if (d.status !== 200) {
        throw new Error('Trasig');
      }
      return d;
    })
    .then((d) => d.json());
};

export const postReturns = (returnQuery: IReturnQuery, returns: IReturn[]) => {
  const { orderNumber, postCode, name, email } = returnQuery;
  return wrappedFetch(
    `${baseUrl}/${source['hybris']}/${orderNumber}?match=${postCode}${
      name && email ? `&name=${name}&email=${email}` : ''
    }`,
    {
      method: 'post',
      body: JSON.stringify(returns),
    },
  );
};
